export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Kun kontant i restauranten. Kortbetaling accepteres ikke.',
  },
};
